import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><filter id=\"a\"><feOffset dx=\"1\" dy=\"1\"></feOffset><feGaussianBlur result=\"offset-blur\" stdDeviation=\"1\"></feGaussianBlur><feComposite in=\"SourceGraphic\" in2=\"offset-blur\" operator=\"out\" result=\"inverse\"></feComposite><feFlood flood-color=\"#000\" flood-opacity=\".3\" result=\"color\"></feFlood><feComposite in=\"color\" in2=\"inverse\" operator=\"in\" result=\"shadow\"></feComposite><feComposite in=\"shadow\" in2=\"SourceGraphic\"></feComposite></filter></defs><path d=\"m100 0 65 40v80l-65 40-65-40V40z\" filter=\"url(#a)\" transform=\"rotate(-20 100 100)\"></path>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }